"use strict";

export default class FileUpload {
  constructor($element) {
    this.$container = $element;
    this.$inputFile = this.$container.querySelector('input[type="file"]');
    this.$fileSelectBtn = this.$container.querySelector('.file-select-button');
    this.$imagePreviewContainer = this.$container.querySelector('.image-preview-container');
    this.$imagePreview = this.$imagePreviewContainer.querySelector('img');

    this.initStyles();
    this.listen();
  }

  initStyles() {
    this.$inputFile.style.display = 'none';

    if (this.$imagePreviewContainer.children.length === 0) {
      this.$imagePreviewContainer.style.margin = 0;
    }
  }

  listen() {
    this.listenFileSelect();
    this.listenUpload();
  }

  listenFileSelect() {
    this.$fileSelectBtn.addEventListener('click', () => {
      if (!this.$inputFile && localStorage.getItem('isDevMode') === '1') {
        throw new Error('No file input found.');
      }

      this.$inputFile.click()
    });
  }

  listenUpload() {
    this.$inputFile.addEventListener('change', () => this.handleFileUpload());
  }

  handleFileUpload() {
    const FILE_LIST = this.$inputFile.files;

    if (FILE_LIST.length == 1) {
      const FILE = FILE_LIST[0];
      const FILE_TYPE = FILE.type;

      if (FILE_TYPE.startsWith("image/")) {
        this.handleImageUpload(FILE);
      }
    } else if (FILE_LIST.length > 0) {
      // TODO: Handle multiple files.
    }
  }

  handleImageUpload(imageFile) {
    if (!this.$imagePreview) {
      this.$imagePreview = document.createElement("img");
      this.$imagePreview.classList.add("image-preview");

      if (this.$imagePreviewContainer.appendChild(this.$imagePreview)) {
        this.$imagePreviewContainer.style.margin = "1rem 0";
      }
    }

    this.$imagePreview.file = imageFile;

    this.readImageFile(this.$imagePreview, imageFile);
  }

  /**
   * Reads the image file and updates the image preview.
   *
   * @param {HTMLImageElement} imagePreview - The image preview element.
   * @param {File} imageFile - The image file to be read.
   */
  readImageFile(imagePreview, imageFile) {
    const FILE_READER = new FileReader();

    FILE_READER.addEventListener('load', e => {
      imagePreview.src = e.target.result;

      if (imagePreview.hasAttribute('srcSet')) {
        imagePreview.removeAttribute('srcSet');
      }
    });

    FILE_READER.readAsDataURL(imageFile);
  }
}
